import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../state/store";
import { enhanceFieldIdValuePairs } from "../utils/expressionEvaluationHelper";

/* Hook that adds selected package to field ID value pairs for expression evaluation */
export const useEnhancedFieldIdValuePairs = (): { [key: string]: string } => {
    const fieldIdValuePairsRaw = useSelector((state: RootState) => state.appSlice.fieldIdValuePairs);
    const selectedPackage = useSelector((state: RootState) => state.appSlice.selectedPackage);
    
    const fieldIdValuePairsFromOrigin = useMemo(() => fieldIdValuePairsRaw ?? {}, [fieldIdValuePairsRaw]);
    
    const enhancedFieldIdValuePairs = useMemo(() => {
        return enhanceFieldIdValuePairs(fieldIdValuePairsFromOrigin, selectedPackage);
    }, [fieldIdValuePairsFromOrigin, selectedPackage]);
    
    return enhancedFieldIdValuePairs;
};
